interface QuantityWithRefund {
  quantity: number;
  refundedQuantity?: number;
  effectiveQuantity?: number;
}

interface QuantityWithRefundLabels {
  fullyRefunded: string;
  refunded: string;
}

export const formatQuantityWithRefund = (
  item: QuantityWithRefund,
  labels: QuantityWithRefundLabels,
) => {
  const quantity = item.quantity ?? 0;
  const refundedQuantity = item.refundedQuantity ?? 0;
  const effectiveQuantity =
    item.effectiveQuantity ?? Math.max(quantity - refundedQuantity, 0);

  if (refundedQuantity <= 0) {
    return String(quantity);
  }

  if (effectiveQuantity <= 0 || refundedQuantity >= quantity) {
    return `${quantity} (${labels.fullyRefunded})`;
  }

  return `${quantity} (${refundedQuantity} ${labels.refunded})`;
};
